export default __webpack_public_path__ + "static/Branching_Hover-ac2d028d3e5a0d45ee0c9b55c4413b8a.png";